import { LayoutOptions } from "./helpers/prop-types-helper";
import * as LayoutOptionTypes from "./layout-options";

import * as Shared from "./shared";

export * from "./blocks";
export * from "./helpers";

const updatedLayoutOptions = Object.assign(LayoutOptions, LayoutOptionTypes);
export { updatedLayoutOptions as LayoutOptions };
export { processLayoutOptions } from "./helpers/prop-types-helper";

export { Shared };

// Reexport everything from `@kameleon-core/types`
// to make depending packages on this library not mandatory to depend on separate types package.
export * from "@kameleon-core/types";
